
import Vue from 'vue';
import Component from 'vue-class-component';

// Components
import { VAppLayout, VAppMain } from '@/components/VApp';
import VButton from '@/components/VButton/VButton.vue';

@Component({
    components: {
        VAppMain,
        VAppLayout,
        VButton,
    },
})
export default class Error404Page extends Vue {
    public refreshPage() {
        window.location.reload();
    }
}
